import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {END_NODE_INFO, ROUTER_NODE_INFO} from 'processes/graph-builder-processes/ProcessFlowchartNodeTypes';
import {ProcessGraphBuilderNodeTemplate} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

// You cannot add a root or output node to the graph builder canvas, so we don't need to account for those
// detail types here
const SchemaOrDragDropKeyToNodeDetailsType: {[key: string]: ProcessFlowchartNodeDetailsType} = {
  [ROUTER_NODE_INFO.nodeDefinition.dropKey]: ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS,
  [END_NODE_INFO.nodeDefinition.dropKey]: ProcessFlowchartNodeDetailsType.END_NODE_DETAILS,
  default: ProcessFlowchartNodeDetailsType.TASK_NODE_DETAILS,
};

function nodeNameExists(
  existingNodeDetailTypesAndNames: Array<{
    nodeDetailsType: ProcessFlowchartNodeDetailsType;
    nodeName: string;
  }>,
  name: string
): boolean {
  return existingNodeDetailTypesAndNames.some((item) => item.nodeName === name);
}

function makeNodeName(
  newNodeType: ProcessFlowchartNodeDetailsType,
  newNodeSchemaOrDragDropKey: string,
  nodeCount: number,
  availableNodes: Array<ProcessGraphBuilderNodeTemplate>
): string {
  let namePrefix = '';
  if (newNodeType === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS) {
    namePrefix = 'Router';
  } else if (newNodeType === ProcessFlowchartNodeDetailsType.END_NODE_DETAILS) {
    namePrefix = 'Stop';
  } else {
    const schemaId = newNodeSchemaOrDragDropKey;
    const sourceSchema = availableNodes.find((node) => node.schemaId === schemaId)!;
    namePrefix = sourceSchema.name;
  }

  return `${namePrefix} ${nodeCount}`;
}

export function getNewNodeName(
  existingNodeDetailTypesAndNames: Array<{
    nodeDetailsType: ProcessFlowchartNodeDetailsType;
    nodeName: string;
  }>,
  newNodeSchemaOrDragDropKey: string,
  nodeCount: number,
  availableNodes: Array<ProcessGraphBuilderNodeTemplate>
): string {
  const newNodeType = SchemaOrDragDropKeyToNodeDetailsType[newNodeSchemaOrDragDropKey];

  let currNodeCount = nodeCount + 1;
  let newNodeName = makeNodeName(newNodeType, newNodeSchemaOrDragDropKey, currNodeCount, availableNodes);

  while (nodeNameExists(existingNodeDetailTypesAndNames, newNodeName)) {
    currNodeCount += 1;
    newNodeName = makeNodeName(newNodeType, newNodeSchemaOrDragDropKey, currNodeCount, availableNodes);
  }

  return newNodeName;
}
